import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesInventory } from "../../constants";

export const requestRestoreInventoryManager = async (
  resellerId: string
): Promise<void> => {
  return await instance.patch(
    buildUrl(
      ApiRoutesInventory.InventoryManager,
      resellerId,
      ApiRoutesInventory.Restore
    )
  );
};
